/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Benefits, UnitEdit } from 'src/app/home/models/benefts.interface';
import { BenefitsService } from 'src/app/home/services/benefits.service';
import { CommmonService } from 'src/app/utils/common.service';
import { PaginatorSelectComponent } from 'src/app/components/paginatorselect/paginatorselect.component';
import { UtilsNotificationService } from 'src/app/utils/utils-notification.service';

@Component({
  selector: 'app-tab-benefits',
  templateUrl: './tab-benefits.component.html',
  styleUrls: ['./tab-benefits.component.scss'],
})
export class TabBenefitsComponent implements OnInit {
  @ViewChild(PaginatorSelectComponent, { static: false })
  childC!: PaginatorSelectComponent;
  isSizeMobile = false;
  showFilterMobile = false;
  benefits!: Benefits[];
  searchTerm = '';
  currentPage = 1;
  totalPages!: number;
  totalRows!: number;
  selectedSortOption = 'order';
  itemsPerPage = 15;
  id!: number;
  idbenefit!: number;
  statusbt!: string;

  changeStatusBenefits: UnitEdit = {
    id: 0,
    idbenefit: 0,
    parameters: {
      statusbt: '',
    },
  };

  dataSource: any = [];

  paginatedBenefits!: Benefits[];
  displayedColumns: string[] = [
    'title',
    'DescriptionCategories',
    'id',
    'createdAt',
    'statusbt',
    'editar',
  ];

  constructor(
    private benefitsService: BenefitsService,
    private commonService: CommmonService,
    private router: Router,
    public utils : UtilsNotificationService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.getbenefits();
  }

  async getbenefits() {
    this.commonService.removeItemLocalStorage('benefits');
    this.benefits = this.commonService.sortArray(
      (await this.benefitsService.getBenefitsGeneral()) ?? [],
    );
    this.commonService.setItemLocalStorage(
      'benefits',
      JSON.stringify(this.benefits),
    );
    this.totalPages = Math.ceil(this.benefits.length / this.itemsPerPage);
    this.totalRows = this.benefits.length;
    this.paginateBenefits(1, this.benefits);
  }

  async editStatusBenefit(objectEdit: any) {
    try {
      await this.benefitsService.putBenefits(objectEdit);
      await this.getbenefits();
    } catch (error) {
      console.error('Error al editar el archivo JSON:', error);
    }
  }

  paginateBenefits(page: number, benefits: Benefits[]) {
    this.paginatedBenefits = benefits.slice(
      (page - 1) * this.itemsPerPage,
      page * this.itemsPerPage,
    );
  }

  onSearch() {
    this.benefits = JSON.parse(
      this.commonService.getItemLocalStorage('benefits') ?? '[]',
    );
    if (this.searchTerm.length >= 1) {
      this.paginatedBenefits = this.filterElements(this.benefits, this.searchTerm)  

      this.totalPages = Math.ceil(
        this.paginatedBenefits.length / this.itemsPerPage,
      );
      this.paginateBenefits(1, this.paginatedBenefits);

      if (this.paginatedBenefits.length === 0) {
        this.paginateBenefits(1, this.paginatedBenefits);
      }
    } else {
      this.totalPages = Math.ceil(this.benefits.length / this.itemsPerPage);
      this.paginateBenefits(1, this.benefits);
    }

    this.childC.getNumberPagesPaginatorSelect(this.currentPage, this.totalPages);
  }

  filterElements(benefits:Benefits[], searchTerm:any){ 
    if (this.searchTerm.toLowerCase().includes('publicado')) {
      this.paginateBenefits(1, benefits);
      let publicada = benefits.filter(req => req.vigencia !== true && req.hidden === false);
      this.totalPages = Math.ceil(publicada.length / this.itemsPerPage);
      return publicada;
    }
    if(this.searchTerm.toLowerCase().includes('oculto')) {
      this.paginateBenefits(1, benefits);
      let oculto = benefits.filter(req => req.vigencia !== true && req.hidden === true);
      this.totalPages = Math.ceil(oculto.length / this.itemsPerPage);
      return oculto;
    }
    if(this.searchTerm.toLowerCase().includes('deshabilitado')) {
      this.paginateBenefits(1, benefits);
      let deshabilitado = benefits.filter(req => req.vigencia === true);
      this.totalPages = Math.ceil(deshabilitado.length / this.itemsPerPage);
      return deshabilitado;
    }
     return benefits.filter(
      (benefit) =>
        benefit.id?.toString().includes(searchTerm) ||  
        benefit.createdAt.toString().includes(searchTerm) ||
        benefit.title
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .includes(this.searchTerm.toLowerCase()) ||
        benefit.title.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        benefit.descriptionCategories.find((x) =>
          x.nombre.toLowerCase().includes(this.searchTerm.toLowerCase()))
        
)
  }

  goAddBenefits(element: any) {
    this.router.navigate(['admin/benefits/add-benefit'], { state: { data: element }});
  }

  async sortBenefits(
    benefits: Benefits[],
    sortBy: string,
  ): Promise<Benefits[]> {
    switch (sortBy) {
      case 'ordertoA':
        return benefits.sort((a, b) => a.title.localeCompare(b.title));

      case 'ordertoZ':
        return benefits.sort((a, b) => b.title.localeCompare(a.title));

      case 'mostOld':
        return benefits.sort(
          (a, b) =>
            new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
        );

      case 'actually':
        return benefits.sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
        );

      default:
        return [...benefits];
    }
  }

  async onSortChange() {
    const ordererBenefits = await this.sortBenefits(
      this.benefits,
      this.selectedSortOption,
    );
    this.paginateBenefits(1, ordererBenefits);
  }

  onSelecPageChange(event: Event) {
    const itemsPerPages1 = (event.target as HTMLInputElement).value;
    this.itemsPerPage = Number(itemsPerPages1);
    this.currentPage = 1;
    this.totalPages = Math.ceil(this.benefits.length / this.itemsPerPage);
    this.paginateBenefits(1, this.benefits);
    this.childC.getNumberPagesPaginatorSelect(this.currentPage, this.totalPages);
  }

  async statusChange(id: number, status: string) {    
        const body = {
                estado_eliminado: !status,
                beneficio_id:id
            }
        await this.putBenefitHidden(body);
      
  }

  onPageChange(page: any) {
    this.currentPage = page;
    this.paginateBenefits(page, this.benefits);
  }

  async putBenefitHidden(body:any){
    try{
       const response =  await this.benefitsService.putBenefithidden(body)
       if(response.statusCode === 200){
        window.location.reload()
       }
    }
    catch(e){
      console.error('error al actualizar:', e);
      
    }
   
  }
}
